import { j as t } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as o } from "@mui/joy";
import { memo as r } from "react";
import { S as a } from "../../../../../../index.BRz-o-Vs.js";
const s = r(({
  syncDirection: e
}) => /* @__PURE__ */ t.jsx(o, { children: e === a.IMPORT ? null : e === a.EXPORT ? "This will export the selected dataset directly as an audience to Meta Ads Manager. The dataset should have only one column with plain email addressed that will be automatically hashed with SHA256. Note: Please access your Meta Ads Manager to verify the created audience." : null }));
s.displayName = "TradeDeskInfo";
export {
  s as default
};
//# sourceMappingURL=MetaInfo.js.map
